<template>
  <div id="huddle_controls" class="flex items-center justify-between px-4 py-2.5 shrink-0 border_top">
    <div class="flex items-center">
      <a-tooltip title="Add people">
        <a-button
          class="secondary_color px-2"
          @click="$emit('open-add-people')"
        >
          <ThemeImage
              class="size-5"
              :icon="imageNames.ADD_MEMBER"
              alt="invite_people"
          />
        </a-button>
      </a-tooltip>
    </div>

    <div class="flex items-center gap-1">
      <div class="flex items-center">
        <a-tooltip :title="isMuted ? 'Unmute' : 'Mute'">
          <a-button
              class="px-2 secondary_medium"
            :disabled="isTogglingMute"
            @click="handleToggleMute"
          >
            <ThemeImage
                class="size-5"
                :icon="isMuted ? imageNames.MUTED_ICON : imageNames.MUTE_ICON"
                alt="mute"
            />
          </a-button>
        </a-tooltip>
      </div>

      <a-tooltip :title="videoEnabled ? 'Turn off camera' : 'Turn on camera'">
        <a-button
            class="px-2 secondary_medium"
            :disabled="isTogglingVideo"
            @click="handleToggleVideo"
        >
          <ThemeImage
              class="size-5"
              :icon="imageNames.VIDEO_ICON"
              alt="video"
          />
        </a-button>
      </a-tooltip>

      <a-tooltip :title="isScreenShareDisabled ? 'Another user is sharing' : screenSharing ? 'Stop sharing' : 'Share screen'">
        <a-button
            class="px-2 secondary_medium"
            :class="{ 'opacity-40 cursor-not-allowed': isScreenShareDisabled }"
            :disabled="isScreenShareDisabled || isTogglingScreenShare"
            @click="handleToggleScreenShare"
        >
          <ThemeImage
              class="size-5"
              :icon="imageNames.SCREEN_SHARE_ICON"
              alt="screen_share"
          />
        </a-button>
      </a-tooltip>
    </div>

    <div class="flex items-center">
      <a-button
          class="danger_medium"
        :disabled="isLeaving"
        @click="handleLeave"
      >
        Leave
      </a-button>
    </div>
  </div>
</template>

<script setup>
import {imageNames} from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { useHuddleControls } from "@/src/composables/useHuddleControls.js";

defineEmits(["open-add-people"]);

const {
  isMuted,
  videoEnabled,
  screenSharing,
  isLeaving,
  isScreenShareDisabled,
  isTogglingMute,
  isTogglingVideo,
  isTogglingScreenShare,
  handleToggleMute,
  handleToggleVideo,
  handleToggleScreenShare,
  handleLeave,
} = useHuddleControls();
</script>
